import { render, staticRenderFns } from "./location.vue?vue&type=template&id=f4187ab2&"
import script from "./location.vue?vue&type=script&lang=js&"
export * from "./location.vue?vue&type=script&lang=js&"
import style0 from "./location.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "location.vue"
export default component.exports